import { List, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  momentDate,
  MuiModalWindow,
  NoData,
  queryParam,
  upperCase,
  useQuery,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import DayWiseMarkedAndPending from "./dayWiseMarkedAndPending";

const DayOrderDates = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);

  const params = useParams();
  let searchParams = queryParam(useQuery());

  useEffect(() => {
    loadDayOrders();
  }, []);

  const loadDayOrders = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("batch", searchParams?.batch);
    form.append("section", searchParams?.section);
    form.append("semester", searchParams?.semester);
    form.append("course_uuid", searchParams?.course_uuid);
    form.append("college_uuid", searchParams?.college_uuid);
    axios.post(ServiceUrl.MOB.LIST_DAY_ORDERS_BY_BATCHSEM, form).then((res) => {
      if (res["data"].status == "1") {
        let m = res["data"].data;
        setDataList(m);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }

      context.setLoader(false);
    });
  };

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance Marked Report`
      : "Attendance Marked Report";
  };

  const bakcLinkClick = () => {
    let path = params?.type ? "/staff/app/my-att-report" : "/staff/app";
    navigate(path);
  };

  return (
    <>
      {/*<Header
        hideLogoText={true}
        onBack={(e) => bakcLinkClick()}
        title={getTitle()}
        backAction={true}
        rightActions={[]}
      />*/}

      <div className="container-sm" data-aos="zoom-in">
        {dataList.length < 1 && <NoData className="py-5 mt-5" />}
        <List>
          {dataList.map((item) => (
            <List.Item
              className="ps-3"
              onClick={(e) => {
                setSelectedDate(item);
                setShowModal(true);
              }}
            >
              {momentDate(item.day_order_date, "DD/MMM/YYYY")}
            </List.Item>
          ))}
        </List>
      </div>

      <MuiModalWindow
        open={showModal}
        onClose={(e) => {
          setShowModal(false);
          setSelectedDate(false);
        }}
        title="Marked List"
      >
        <section>
          <div className="container-sm">
            <DayWiseMarkedAndPending
              dayOrder={selectedDate}
              college_uuid={searchParams?.college_uuid}
            />
          </div>
        </section>
      </MuiModalWindow>

      {/*<Modal
        show={showModal}
        onHide={(e) => {
          setShowModal(false);
          setSelectedDate(false);
        }}
        fullscreen
      >
        <Modal.Header className="fw-bold" closeButton>
          Marked List
        </Modal.Header>
        <Modal.Body>
          <DayWiseMarkedAndPending dayOrder={selectedDate} />
        </Modal.Body>
      </Modal>*/}
    </>
  );
};
export default DayOrderDates;
